import { h } from 'preact'; /** @jsx h */

import './DeliveryInfo.scss';

const DeliveryInfo = ({ cart }) => {
    // Check if any product in the cart has a shipmentType
    const hasShipmentType = cart.some(product => product.shipmentType);

    // If no product has a shipmentType, return null to render nothing
    if (!hasShipmentType) {
        return null;
    }

    return (
        <div className="ws-order-user-info">
            <div className="user-info-header action">
                <div className="header-content">
                    <span className="header-number">2</span>
                    <h6 className="header-title">Fraktinformasjon</h6>
                </div>
                <div className="header-action"></div>
            </div>
            <div className="user-info-content">
                {cart.some(
                    product =>
                        product.shipmentType === 'Gavebevis på e-post' ||
                        product.shipmentType === 'PDF på e-post'
                ) && (
                    <div className="delivery-option">
                        <div className="option-text">
                            <p className="delivery-title">E-post</p>
                            <p className="delivery-text">
                                Gavebevis som er bestilt med leveringsmetode «Gavebevis på e-post»
                                vil sendes på e-post til e-postadressen du har registrert.
                            </p>
                        </div>
                        <div className="option-icon">
                            <span className="material-symbols-outlined icon">attach_email</span>
                        </div>
                    </div>
                )}
                {cart.some(product => product.shipmentType === 'Gavebevis i posten') && (
                    <div className="delivery-option">
                        <div className="option-text">
                            <p className="delivery-title">Posten</p>
                            <p className="delivery-text">
                                Gavebevis og produkter som er bestilt med leveringsmetode «Gavebevis
                                i posten» eller «Produkt i posten» vil bli levert med Posten til
                                nærmeste hentested eller i din postkasse.
                            </p>
                        </div>
                        <div className="option-icon">
                            <img
                                src="https://norskluftambulanse.no/wp-content/uploads/2023/12/posten-logo.png"
                                alt="Posten logo"
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DeliveryInfo;
